module.exports = __webpack_public_path__ + "img/刑诉法.e2be3d52.png";